document.querySelectorAll('.meaulink').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();

      const targetId = this.getAttribute('href'); // 获取 #productdetail 等
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    });
  });

  const sectionsContainer = document.querySelector(".dkmaincontent"),
  sections = document.querySelectorAll(".targetlink"),
  nav = document.querySelector(".mainmeau"),
  menu = nav.querySelector(".meauitem"),
  links = nav.querySelectorAll(".meaulink"),
  sectionOffset = nav.offsetHeight + 24,
  activeClass = "activelink";
let activeIndex = 0,
  isScrolling,
  userScroll = !0;
  setActiveClass = () => {
    links[activeIndex].classList.add(activeClass);
  },
  removeActiveClass = () => {
    links[activeIndex].classList.remove(activeClass);
  },
  setMenuLeftPosition = (position) => {
    menu.scrollTo({ left: position, behavior: "smooth" });
  },
  checkMenuOverflow = () => {
    const activeLink = links[activeIndex].getBoundingClientRect(),
      offset = 30;
    Math.floor(activeLink.right) > window.innerWidth
      ? setMenuLeftPosition(
          menu.scrollLeft + activeLink.right - window.innerWidth + offset,
        )
      : activeLink.left < 0 &&
        setMenuLeftPosition(menu.scrollLeft + activeLink.left - offset);
  },
  handleActiveLinkUpdate = (current) => {
    (removeActiveClass(),
      (activeIndex = current),
      checkMenuOverflow(),
      setActiveClass());
  };
(links.forEach((link, index) => {
  link.addEventListener("click", (e) => {
    ((userScroll = !1), handleActiveLinkUpdate(index));
  });
}),

  window.addEventListener("scroll", () => {
    let currentIndex;
    if (sectionsContainer.getBoundingClientRect().top < 0) {
      const foundIndexFromBottom = [...sections]
        .reverse()
        .findIndex((section) => window.scrollY >= section.offsetTop);
      currentIndex = sections.length - 1 - foundIndexFromBottom;
    } else currentIndex = 0;
    userScroll && activeIndex !== currentIndex
      ? handleActiveLinkUpdate(currentIndex)
      : (clearTimeout(isScrolling),
        (isScrolling = setTimeout(() => {
          userScroll = !0;
        }, 100)));
  }),
  init());